export const getData = (state) => {
    return state;
}